exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recipe-gallery{display:flex;flex-wrap:wrap;margin:0 -10px 0}.recipe-gallery__item{margin:0 10px 20px}.recipe-gallery__item:last-child{margin-right:0}.recipe-gallery__image{border-radius:3px}.recipe-gallery__container{margin-top:40px}@media print{.recipe-gallery__container{display:none}}\n", ""]);

// exports
exports.locals = {
	"recipe-gallery": "recipe-gallery",
	"recipe-gallery__item": "recipe-gallery__item",
	"recipe-gallery__image": "recipe-gallery__image",
	"recipe-gallery__container": "recipe-gallery__container"
};